<template>
  <ModalTemplate
    :titulo="titulo"
    :visivel="visivel"
    :botoes="botoes"
    :largura-modal="larguraModal"
    @pressionar-botao="fecharModal"
    @fechar-modal="fecharModal"
  >
    <template #body>
      <img 
        :src="imagem" 
        :alt="textoPrimario"
        class="tw-mb-2.5 tw-mx-auto"
        width="162.36"
        height="150"
      >
      <span class="tw-block tw-text-azul800 tw-text-base tw-font-bold tw-mb-2 tw-text-center">
        {{ textoPrimario }}
      </span>
      <span class="tw-block tw-text-neutral-500 tw-text-xs tw-font-normal tw-text-center">
        {{ textoSecundario }}
      </span>
    </template>
  </ModalTemplate>
</template>

<script>
import ModalTemplate from '@/ecdt-components/modals/ModalTemplate.vue';
import ImagemAviao from '@/assets/images/icons/aviao-papel.svg';

export default {
  components: {
    ModalTemplate
  },
  props: {
    titulo: {
      type: String,
      required: true
    },
    visivel: {
      type: Boolean,
      required: true
    },
    textoPrimario: {
      type: String,
      required: false,
      default: ''
    },
    textoSecundario: {
      type: String,
      required: false,
      default: ''
    },
    imagem: {
      type: String,
      required: false,
      default: ImagemAviao
    },
    larguraModal: {
      type: String,
      required: false,
      default: '435'
    }
  },
  data() {
    return {
      botoes: [
        {
          texto: 'Fechar',
          valor: 'fechar',
          estilo: 'botao-outlined-cinza'
        }
      ]
    }
  },
  methods: {
    fecharModal() {
      this.$emit('fechar-modal');
    }
  }
}
</script>
